const BaseEntry = require('./BaseEntry');
const getConstants = require('../../../utils/getConstants');
const constants = getConstants();
const { answerStates } = constants;

class TextEntry extends BaseEntry {
   constructor(aggregateRoot, componentData, items, entries, ruleEvaluator) {
      super(aggregateRoot, componentData, items, entries, ruleEvaluator);
   }

   update({ actionedOn, text, geoLat, geoLong, geoTimeStamp }) {
      const item = this.item;

      const newItemState = item.state | answerStates.ANSWERED;

      const noResponse = item.response ? item.response.no : 1;

      var p = {
         idItem: this.idItem,
         state: newItemState,
         actionedOn,
         noResponse: noResponse,
         val: text,
         noSubmissionItem: item.no,
         noSubmission: this._aggregateRoot.getSubmissionNo(),
         geoLat,
         geoLong,
         geoTimeStamp
      };

      this.apply('TEXT_FIELD_UPDATED', p);

      item.response = item.response || {};
      item.response.no = noResponse;
      item.response.val = text;
      item.response.actionedOn = actionedOn;
      item.state = newItemState;
      item.geoLat = geoLat;
      item.geoLong = geoLong;
      item.geoTimeStamp = geoTimeStamp;
   }

   lock() {
      const item = this.item;
      const { state } = item;
      item.state = state | answerStates.LOCKED;
   }

   unlock() {
      const item = this.item;
      const { state } = item;
      item.state = state & ~answerStates.LOCKED;
   }

   isValid() {
      const item = this.item;
      const { state } = item;

      let isInvalid = false;

      let isSkipped = (state & answerStates.SKIPPED) == answerStates.SKIPPED;

      if ((item.response == null || item.response.val == null || item.response.val.trim() === '') && !isSkipped) {
         isInvalid = true;
      }

      return !isInvalid;
   }

   validate() {
      const isValid = this.isValid();
      return this.setCurrentValidity(isValid);
   }

   getFriendlyValue() {
      const item = this.item;
      const value = item.response && item.response.val !== undefined ? item.response.val : '';
      return value;
   }
}

module.exports = TextEntry;
